<div class="table-clock" 
    [ngStyle]="{left: clockData?.positionClock + 'px', height: clockData?.heightClock + 'px', top: '48px'}"
    [ngbTooltip]="clockTooltip">
    <ng-template #clockTooltip>
        {{ clockData?.currentTime[0] + ':' + clockData?.currentTime[1] }}
    </ng-template> 
</div>